import * as React from "react";
import { Button, Grid, TextField } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { postNotification } from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import { signIn } from "./CognitoSignInForm";
import { postData } from "../../utils/APIUtilities";

export async function verifyForgotPassword(
  verifyInfo,
  setProcessing,
  navigate
) {
  const { username, password, verifyCode } = verifyInfo;

  if (!(username && password && verifyCode)) {
    postNotification("error", "Missing required fields");
    return;
  }

  setProcessing(true);

  try {
    await postData("/users/confirmforgotpassword", {
      body: {
        email: username.trim().toLowerCase(),
        password: password,
        verificationCode: verifyCode,
      },
    });
    postNotification("success", "Password Updated, logging you in!");
    await signIn(
      { username: username.trim().toLowerCase(), password },
      setProcessing,
      navigate
    );
  } catch (error) {
    postNotification("error", error, true);
  } finally {
    setProcessing(false);
  }
}

export default function CognitoVerifyForgotPasswordForm({
  formState,
  updateFormState,
  updateFormType,
  setProcessing,
}) {
  const navigate = useNavigate();
  const onSubmit = async (values) => {
    updateFormState(values);
    await verifyForgotPassword(values, setProcessing, navigate);
  };

  return (
    <Formik
      initialValues={{
        username: formState?.username || formState?.email || null,
        password: null,
        verifyCode: formState?.verifyCode || null,
      }}
      validationSchema={Yup.object().shape({
        username: Yup.string().nullable().max(128).required("Required"),
        password: Yup.string().nullable().max(128).required("Required"),
        verifyCode: Yup.string().nullable().max(255).required("Required"),
      })}
      onSubmit={onSubmit.bind(this)}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                error={Boolean(touched.username && errors.username)}
                helperText={touched.username && errors.username}
                autoComplete="username"
                name="username"
                value={values.username}
                label={"Email"}
                variant="outlined"
                required
                fullWidth
                onBlur={handleBlur}
                onChange={(e) => {
                  const trimmedString = e.target.value.trim().toLowerCase();
                  setFieldValue("username", trimmedString);
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                error={Boolean(touched.verifyCode && errors.verifyCode)}
                helperText={touched.verifyCode && errors.verifyCode}
                name="verifyCode"
                value={values.verifyCode}
                label="Verification Code"
                variant="outlined"
                required
                fullWidth
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                error={Boolean(touched.password && errors.password)}
                helperText={touched.password && errors.password}
                autoComplete="password"
                name="password"
                value={values.password}
                type="password"
                label="Password"
                variant="outlined"
                required
                fullWidth
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <Button type="submit" fullWidth variant="contained">
                Update
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
}
